<template>
  
  <SmallSquare :padding='true' content="1､申请自定义签名条件：
  （1）商户必须通过企业认证，并以营业执照上公司简称申请签名；
  （2）签名内容一般为3~8个字，无需添加【】，不能是纯字母、纯数字或其他特殊字母符号(如-.+#)，且不含违禁关键词。
  2､默认签名为【高大永恒塑料制品有限公司】。提交签名后，运营商将在1-3个工作日完成审核，审核通过后自动采用新签名。
  3､为保障短信通道安全，审核通过后的签名不能修改，请谨慎填写。" />
  <a-card :bordered='false'>
    <a-form :model="form" :label-col="{span:3}" :wrapper-col="{span:8}">
      <a-form-item label="当前签名格式：" name='thatSign'>【{{form.thatSign}}】</a-form-item>
      <a-form-item label="自定义签名" name='sign' :help="form.sign.length+'/8'">
        <a-textarea v-model:value="form.sign" placeholder="自定义签名以营业执照名称为准,不需要加【】" :maxlength="8" :rows="4" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:3}">
        <a-button type="primary" v-has:smsSignatureSubmit="onSubmit">
          提交审核
        </a-button>
      </a-form-item>
    </a-form>
  </a-card> 
  <a-card class="m-t-15" :bordered='false' title="审核记录">
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:status="{ record }">
        <p v-if='record.status == -1'>提交异常</p>
        <p v-if='record.status == 0'>未提交</p>
        <p v-if='record.status == 1'>审核中</p>
        <p v-if='record.status == 2'>已通过</p>
        <p v-if='record.status == 3'>已拒绝</p>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>

<script>
  import { getSignList, addSign, getSignDetail } from '@/api/message'
  import { reactive, ref, toRefs, onMounted } from 'vue'
  import { message } from 'ant-design-vue'
  import { iscode } from '@/utils/app';
  export default {
    setup() {

      const state = reactive({
        listLoading: false,
        data: [],
        total: 0
      })
      const form = ref({ sign: '', thatSign: '' })
      const getThatSign = async () => {
        let result = await getSignDetail().then(res => res.data).catch(error => error)
        if (result.data.sign) {
          form.value.thatSign = result.data.sign
        }
      }
      const search = ref({ page: 1, limit: 10 })
      const initData = async () => {
        state.listLoading = true
        let result = await getSignList(search.value).then(res => res.data).catch(error => error)
        state.listLoading = false
        state.data = result.data.sign.data
        state.total = result.data.sign.total
      }
      onMounted(() => {
        initData()
        getThatSign()
      })
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData();
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData();
      };

      let columns = [
        {
          title: "提交日期",
          dataIndex: "create_time",
          key: "create_time",
          width:180
        },
        {
          title: "签名",
          dataIndex: "sign",
          key: "sign",
          width:200
        },
        {
          title: "操作账号",
          dataIndex: "account",
          key: "account",
          width:180
        },
        {
          title: "审核结果",
          dataIndex: "status",
          key: "status",
          width:150,
          slots: { customRender: "status" },
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
        }
      ];
      const onSubmit = async () => {
        if (!form.value.sign) {
          message.error('请输入自定义签名')
          return;
        }
        let result = await addSign({ sign: form.value.sign }).then(res => res.data).catch(error => error)
        if (iscode(result, true)) {
          initData();
        }
      }
      return {
        search,
        form,
        columns,
        pageCurrentChange,
        pageSizeChange,
        onSubmit,
        ...toRefs(state),
      }
    }
  }
</script>